import { Table } from 'antd';
import { useStore } from '@nanostores/react';
import { store } from './state';

const columns = [
  {
    title: '用户ID',
    dataIndex: 'UserId',
    key: 'UserId',
  },
  {
    title: '变更前分数',
    dataIndex: 'BeforeScore',
    key: 'BeforeScore',
  },
  {
    title: '变更后分数',
    dataIndex: 'AfterScore',
    key: 'AfterScore',
  },
  {
    title: '分数变化',
    dataIndex: 'DeductScore',
    key: 'DeductScore',
  },
  {
    title: '原因',
    dataIndex: 'Reason',
    key: 'Reason',
  },
  {
    title: '类型',
    dataIndex: 'Type',
    key: 'Type',
  },
  {
    title: '关联ID',
    dataIndex: 'RelatedId',
    key: 'RelatedId',
  },
  {
    title: '备注',
    dataIndex: 'Remark',
    key: 'Remark',
  },
  {
    title: '变化时间',
    dataIndex: 'CreatedAt',
    key: 'CreatedAt',
  },
];

export function CreditHistory() {
  const state = useStore(store);

  return (
    <div>
      <div style={{ margin: '24px 0', textAlign: 'left' }}>
        <span style={{ display: 'inline-block' }}>信誉分变化历史</span>
      </div>
      <Table dataSource={state.list} columns={columns} />
    </div>
  );
}
